/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Component */
import TestimonialGroup from '@components/Sliders/TestimonialGroup';
import SectionUI from '@components/UI/Common/SectionUI';

/* Services  */
/* Styles */

/**
 * Renders Expression Component
 * @param {Object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 */
const Expressions = ({ sectionContent, lang, region }) => {
  //Right Arrow  for the slider
  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        textAlign={'center'}
        top={{ base: '27%', sm: '26%', md: '25%' }}
        zIndex="10"
        cursor="pointer"
        d={{ md: 'none', sm: 'block', base: 'block' }}
        bgColor="#fff"
        border="0"
        borderRadius="100%"
        w="40px"
        h="40px"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        backgroundImage={`url('/assets/images/right-arrow.svg)`}
        right="-10px"
        bgSize="10px"
        onClick={onClick}
        boxShadow="0 0 15px 0 rgb(0 0 0 / 30%)"
      ></Box>
    );
  };
  // Left Arrow for the Slider
  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        top={{ base: '27%', sm: '26%', md: '25%' }}
        zIndex="10"
        cursor="pointer"
        d={{ md: 'none', sm: 'block', base: 'block' }}
        bgSize="10px"
        bgColor="#fff"
        border="0"
        borderRadius="100%"
        w="40px"
        h="40px"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url('/assets/images/left-arrow.svg')`}
        left="-10px"
        onClick={onClick}
        boxShadow="0 0 15px 0 rgb(0 0 0 / 30%)"
      />
    );
  };

  // Slider setting for the Slider
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Box w="full">
      <Box
        width={'100%'}
        height="auto"
        pb="50px"
        background="#F7F7F7"
        px={{
          xl: 'calc((100% - 1112px) / 2)',
          lg: '18px',
          md: '18px',
          sm: '18px',
          base: '18px',
        }}
      >
        {sectionContent && sectionContent.length
          ? sectionContent.map(section => {
              if (section._modelApiKey === 'testimonials_group') {
                return (
                  <Box
                    key={nanoid(5)}
                    display="flex"
                    marginTop="20px"
                    paddingTop="40px"
                    border="2px"
                    borderColor="transparent"
                  >
                    <TestimonialGroup
                      testimonialsObj={section}
                      region={region}
                      lang={lang}
                    />
                  </Box>
                );
              }
              return (
                <SectionUI
                  key={nanoid(4)}
                  sectionContent={section}
                  region={region}
                  language={lang}
                />
              );
            })
          : null}
      </Box>
    </Box>
  );
};

export default Expressions;
